import { getOrderedValue } from '../../../Order';
import { getEstimationForSku } from '../../../estimations/Estimations';
import OrderValidationResult from '../OrderValidationResult';
import OrderChangeRequested from '../../../../application/order/events/OrderChangeRequested';
import State from '../../../../application/core/State';
import StockError from '../error';
import { roundValueToMinPackageSize } from '../../../roundValueToPackageSize';

export default (event: OrderChangeRequested, state: State): OrderValidationResult => {
    let validValue = event.value;
    let notificationMessage: StockError = StockError.Null;
    const ordered = getOrderedValue(event.sku, state.order.orderedSku);
    const estimated = getEstimationForSku(state.order.articlesEstimations, event.product.articleId, event.sku);
    const availableValue = estimated === 0 ? 0 : estimated - ordered;
    if (availableValue < event.value) {
        validValue = roundValueToMinPackageSize(availableValue, event.product.packageSize);
        notificationMessage = StockError.CheckoutValueExceedEstimatedValue;
    }
    return {
        notification: notificationMessage,
        value: validValue
    };
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/checkout/checkIfCheckoutOrderExceedEstimatedValue.ts